import { MessageSquarePlus, SlidersHorizontal, Rocket } from "lucide-react";

const STEPS = [
  {
    icon: MessageSquarePlus,
    step: "01",
    title: "Tell it about your business",
    body: "Describe your services, tone and goals. Your AI agent learns how to speak for your brand.",
  },
  {
    icon: SlidersHorizontal,
    step: "02",
    title: "Shape your agents & campaigns",
    body: "Configure voice agents, build marketing journeys and organise your pipeline — no code needed.",
  },
  {
    icon: Rocket,
    step: "03",
    title: "Go live and grow",
    body: "Calls get answered, leads get followed up and campaigns keep running while you focus on the work.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="border-t border-neutral-100 bg-neutral-50/60 py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-400">How it works</p>
          <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#111111] sm:text-5xl">
            Up and running in three steps
          </h2>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {STEPS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.step}
                data-testid={`how-step-${s.step}`}
                className="group rounded-3xl border border-neutral-200 bg-white p-8 transition-all hover:-translate-y-1 hover:shadow-[0_24px_48px_-24px_rgba(0,0,0,0.15)]"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#111111] text-white transition-transform group-hover:scale-105">
                    <Icon size={20} />
                  </span>
                  <span className="text-4xl font-extrabold text-neutral-100 transition-colors group-hover:text-neutral-200">
                    {s.step}
                  </span>
                </div>
                <h3 className="mt-6 text-lg font-bold text-[#111111]">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-neutral-500">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
